export default __webpack_public_path__ + "static/layout-example-sideNav-dark-871e08adb6d4326121bc6b0eddb2d588.png";